import { numberWithDotAndCommas } from "../../../../../../../../utils/numberWithDotAndComas";
import { COLORS, Typo } from "../../../../../../../layout/theme";
import { OrderProductsTable, TableContainer } from "./styles";

export default function OrderTable({ data }) {
	const columns = [
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>PRODUCTO</div>
			),
			dataIndex: "productTitle",
			render: (value) => (
				<Typo type="secondary" fontWeight={600} fontSize={14}>
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>PRECIO</div>
			),
			dataIndex: "price",
			render: (value) => (
				<Typo type="darkGrey" fontWeight={600} fontSize={14}>
					${numberWithDotAndCommas(value)}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>DESC.</div>
			),
			dataIndex: "offerPrice",
			render: (value, record) => (
				<Typo type="success" fontWeight={700} fontSize={14}>
					{`${numberWithDotAndCommas(
						(100 - (record.offerPrice * 100) / record.price).toFixed(2),
					)}%`}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>CANT.</div>
			),
			dataIndex: "quantity",
			render: (value) => (
				<Typo type="darkGrey" fontWeight={600} fontSize={14}>
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>FINAL</div>
			),
			dataIndex: "offerPrice",
			render: (value, r) => (
				<Typo type="darkGrey" fontWeight={600} fontSize={14}>
					${numberWithDotAndCommas((value * r.quantity).toFixed(2))}
				</Typo>
			),
		},
	];

	return (
		<TableContainer>
			<OrderProductsTable
				showHeader={true}
				columns={columns}
				dataSource={data.items}
				pagination={false}
			/>
		</TableContainer>
	);
}
